var noviNs = noviNs || {};

(function (noviNs) {
    noviNs.getMaxQty = function (qty, hasLimitedQty, availableQtySet, qtySold) {
        if (!hasLimitedQty) {
            return qty;
        }

        var remainingQty = noviNs.calcQtyRemaining(qty, hasLimitedQty, availableQtySet, qtySold);

        if (remainingQty < 0) {
            var maxQty = qty - -(remainingQty);
            return maxQty < 0 ? 0 : maxQty;
        }
        return qty;
    };

    noviNs.calcQtyRemaining = function (qty, hasLimitedQty, availableQtySet, qtySold) {
        if (!hasLimitedQty) {
            return 999999;
        }
        var remainingQtyAvailable = availableQtySet - (qtySold + qty);
        return remainingQtyAvailable;
    };

    noviNs.isValidQty = function (qty, hasLimitedQty, availableQtySet, qtySold) {
        if (!hasLimitedQty) {
            return true;
        }
        return noviNs.calcQtyRemaining(qty, hasLimitedQty, availableQtySet, qtySold) >= 0;
    };
})(noviNs);

function ClearPurchaseForm() {
    parent.$("#added-to-cart-modal").find("a, button").blur();
    parent.$("#added-to-cart-modal").modal("hide");
    $('[id*="CustomField"]').each(ClearInput);

    const qty = 1;
    const customFieldValues = GetCustomFieldValues($("#purchase-form"));

    let donationAmount = $("#Price").val();
    donationAmount = parseFloat(donationAmount).toFixed(2);
    if (isNaN(donationAmount)) {
        donationAmount = 0;
    }

    AddProductToCartSilent(qty, customFieldValues, donationAmount);
}

function AddProductToCartSilent(qty, customFieldValues, donationAmount) {
    $.ajax({
        url: addToCartUrl,
        type: 'POST',
        dataType: "json",
        data: {
            "productID": productID,
            "quantity": qty,
            "donationAmount": donationAmount,
            "customFieldValues": customFieldValues
        },
        success: function (data) {
            if (data.Status === "OK") {
                const itemCount = data.Items;
                if (typeof parent.profileViewModel !== 'undefined') {
                    parent.profileViewModel.CartItemQuantity(itemCount);
                }
            } else {
                ShowCustomAlert("There was a problem adding the additional item.");
            }
        },
        error: function () {
            ShowCustomAlert("Server error while adding another item.");
        }
    });
}

function wireUpSelectize() {
    $(".masked").each(function () {
        SetupMaskedInput($(this));
    });

    $("select.use-selectize-multi").each(function () {
        ApplySelectionLimits($(this));
    });

    $(".selectized.required[name*='CustomField_']").bind("change", ValidateSelect);
}

$(function () {
    var inModal = parent.jQuery && parent.$("#iframe-modal .modal-body").length > 0;
    const originalPriceValue = $("#Price").val();
    if (inModal) {
        $("body").addClass("in-modal");

        if (parent.jQuery) {
            var iframeModal = parent.$("#iframe-modal");
            iframeModal.find(".modal-body > .loading").remove();
            iframeModal.find(".modal-title").html($("h1").html());
            if (iframeModal.find(".modal-subtitle").length == 0)
                iframeModal.find(".modal-title").after('<h5 class="modal-subtitle">' + $(".subtitle").html() + '</h5>');
            iframeModal.find(".modal-subtitle").html($(".subtitle").html());
        }

        $(".header-ribbon").remove();
    }

    wireUpSelectize();

    $(".sign-in,.log-in").click(function () {
        parent.window.location.href = $(this).attr("href");
        return false;
    });

    $("#Price").on('focus', function (e) {
        $("#Price").val('');
    })

    $("#Price").on('focusout', function (e) {
        const price = $("#Price").val();
        if (!price) {
            $("#Price").val(originalPriceValue);
        }
    })

    $("#quantity").on('keyup change', function (e) {
        var qtyElement = $(this);
        if (qtyElement && qtyElement.length > 0) {
            var actualVal = qtyElement.val();
            if (actualVal === "" || isNaN(actualVal))
                qtyElement.val("");
            var intVal = qtyElement.val() === "" ? -1 : parseInt(qtyElement.val());
            if (intVal >= 0) {
                qtyElement.val(intVal);
            }
        }
        var qty = qtyElement.val() === "" ? -1 : parseInt(qtyElement.val());
        var isValidQty = qty === -1 ? true : noviNs.isValidQty(qty, noviNs.productVm.hasLimitedQuantity, noviNs.productVm.quantityAvailable, noviNs.productVm.quantitySold);
        if (!isValidQty) {
            var maxQty = noviNs.getMaxQty(qty, noviNs.productVm.hasLimitedQuantity, noviNs.productVm.quantityAvailable, noviNs.productVm.quantitySold);
            ShowCustomAlert('The maximum quantity you can purchase is ' + maxQty + '.');
            qtyElement.val(maxQty);
        }
    });

    if (typeof $('form').validate() !== 'undefined') {
        $('form').validate().settings.ignore = ":hidden:not([class~=selectized]):not(.tinymce),:hidden > .selectized, .selectize-control .selectize-input input, .ignore";
    }

    $("#add-to-cart").click(function () {
        if (!$("#purchase-form").valid())
            return false;

        const qty = $("#quantity").length > 0 && $("#quantity").val() !== "" && !isNaN(parseInt($("#quantity").val())) && parseInt($("#quantity").val()) > 0 ? $("#quantity").val() : 1;
        const customFieldValues = GetCustomFieldValues($("#purchase-form"));

        let donationAmount = $("#Price").val();
        donationAmount = parseFloat(donationAmount).toFixed(2);
        if (isNaN(donationAmount)) {
            donationAmount = 0;
        }

        $("[data-valmsg-for^='CustomField_']").html("");

        $.ajax({
            url: addToCartUrl,
            type: 'POST',
            dataType: "json",
            data: {
                "productID": productID,
                "quantity": qty,
                "donationAmount": donationAmount,
                "customFieldValues": customFieldValues
            },
            success: function (data) {
                if (data.Status == "OK") {
                    var itemCount = data.Items;
                    var itemsInCartElement = (inModal && parent.jQuery) ? parent.$(".items-in-cart") : $(".items-in-cart");
                    var cart = (inModal && parent.jQuery) ? parent.$(".cart") : $(".cart");
                    itemsInCartElement.html(itemCount);
                    cart.removeClass("hide");

                    var addedModal = $("#added-to-cart-modal");
                    if (inModal && parent.jQuery) {
                        parent.$("body").append(addedModal);
                        parent.$("#added-to-cart-modal").modal();
                        parent.$("#iframe-modal").modal("hide");
                    } else {
                        addedModal.modal();
                    }

                    UpdateCartItemQuantity(itemCount);
                } else if (data.Status == "Error") {
                    if (data.Errors) {
                        data.Errors.forEach((customFieldID) => {
                            $(`[data-valmsg-for='CustomField_${customFieldID}']`).html("This field is required.");
                        });
                    }

                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON) {
                    ShowCustomAlert(jqXHR.responseJSON);
                } else {
                    ShowCustomAlert("There was a problem adding this item to your cart.  Please try again later.");
                }
            }
        });

        return false;
    });

    $("#contact-offline").click(function () {
        $(".contact-box").slideToggle();

        // We need this in a setTimeout because the animation driving the contact-box is not immediate.  Half a second is needed for the Dom to be updated.
        // This block updates the aria-expanded property on a button for the product details page that is not handled by the library.
        setTimeout(function () {
            if ($(".contact-box").is(":visible")) {
                $("html,body").stop().animate({ scrollTop: $(".contact-box").offset().top });
                $("#contact-offline").attr("aria-expanded", "true");
            }
            else {
                $("#contact-offline").attr("aria-expanded", "false");
            }
        }, 500);

        return false;
    });

    $("#contact-form").submit(function () {
        var thisForm = $(this);
        if (!thisForm.valid()) {
            return false;
        }

        var saveBtn = thisForm.find(".btn[type=submit]");
        saveBtn.addClass("hide");
        saveBtn.before('<span class="saving"><span class="novicon novicon-spinner novicon-spin"></span>Saving...</span>');
        saveBtn.parent().find(".alert").remove();

        $.ajax({
            url: thisForm.attr('action'),
            type: 'POST',
            dataType: "json",
            data: $(this).serialize(),
            success: function (data) {
                if (data.Status != "OK") {
                    saveBtn.parent().prepend('<div class="alert alert-danger"><span class="novicon novicon-warning"></span>' + data.Errors + '</div>');
                    thisForm.find(".saving").remove();
                    saveBtn.removeClass("hide");
                }
                else {
                    $("#contact-success").removeClass("hide");
                    $(".contact-box").remove();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON) {
                    ShowCustomAlert(jqXHR.responseJSON);
                } else {
                    saveBtn.parents(".buttons").prepend('<div class="alert alert-danger"><span class="novicon novicon-warning"></span>' + jqXHR.responseText + '</div>');
                }

                thisForm.find(".saving").remove();
                saveBtn.removeClass("hide");
            }
        });

        return false;
    });
});